<script setup>
import { Empty } from "@/shared/ui/empty";

defineProps({
  selectedParticipant: { type: Object, default: null },
  selectedService: { type: Object, default: null },
  form: { type: Object, default: () => ({}) },
  inheritanceId: { type: String, default: "" },
  showInheritanceServices: { type: Boolean, default: false },
});
</script>

<template>
  <Empty>
    {{ $t("Внутренние базы недоступны в кабинете клиента") }}
  </Empty>
</template>
